import React, { useState } from 'react';
import { Button } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import KnowledgeBaseEntryDrawer, { KnowledgeBaseEntryDraft } from './KnowledgeBaseEntryDrawer';

interface Props {
  userId?: string;
  draft: KnowledgeBaseEntryDraft;
  size?: 'small' | 'middle' | 'large';
  type?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  className?: string;
  style?: React.CSSProperties;
  buttonLabel?: string;
}

const AddToKnowledgeBaseButton: React.FC<Props> = ({
  userId = '',
  draft,
  size = 'small',
  type = 'default',
  className,
  style,
  buttonLabel = 'Add to Knowledge Base',
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size={size}
        type={type}
        icon={<BookOutlined />}
        onClick={() => setOpen(true)}
        className={className}
        style={style}
      >
        {buttonLabel}
      </Button>
      <KnowledgeBaseEntryDrawer
        open={open}
        onClose={() => setOpen(false)}
        draft={draft}
        userId={userId}
      />
    </>
  );
};

export default AddToKnowledgeBaseButton;
